import * as React from "react";
import {Pagination} from "react-bootstrap";


interface DataFramePaginationProps {
    cpn: number
    totalPages: number
    setCPN: (pn: number | ((n: number) => number)) => void
   
}

const DataFramePagination: React.FC<DataFramePaginationProps> = (props) => {
    
    let {cpn, totalPages, setCPN, } = props;


    // Create the page indexes
    let pageNumbers = [];
    for (let i = 0; i < totalPages; i++) {
        pageNumbers.push(i);
    }

    // For less than 5 pages it display the full index
    if (totalPages > 1 && totalPages < 5) {
        return (
            <Pagination>
                {pageNumbers.map((idx) =>
                    <Pagination.Item key={idx} onClick={() => setCPN(idx)} active={idx === cpn}>
                        {idx + 1}
                    </Pagination.Item>
                    
                )}
              
            </Pagination>
        );
    }
     // For only 1 page display the unable index
     if (totalPages === 1) {
        return (
            <Pagination>
                {pageNumbers.map((idx) =>
                    <Pagination.Item key={idx} active>
                        {idx + 1}
                    </Pagination.Item>
                )}
               
            </Pagination>
        );
    }

     // For more than 4 pages, show dynamic pagination
     const maxDisplayedPages = 3; // Number of pages to show around the current page
     const pages = [];
 
     const startPage = Math.max(0, cpn - 1); // At least one page before the current page
     const endPage = Math.min(totalPages - 1, cpn + maxDisplayedPages - 1); // Up to maxDisplayedPages pages
 
     for (let i = startPage; i <= endPage; i++) {
         pages.push(
             <Pagination.Item
                 key={i}
                 active={i === cpn}
                 onClick={() => setCPN(i)}
             >
                 {i + 1}
             </Pagination.Item>
         );
     }
 
     return (
         <Pagination>
             <Pagination.First onClick={() => setCPN(0)} />
             <Pagination.Prev onClick={() => setCPN((cp) => Math.max(0, cp - 1))} />
 
             {cpn > 1 && <Pagination.Ellipsis onClick={() => setCPN(cpn - maxDisplayedPages)} />}
 
             {pages}
 
             {cpn < totalPages - maxDisplayedPages && (
                 <Pagination.Ellipsis onClick={() => setCPN(cpn + maxDisplayedPages)} />
             )}
 
             <Pagination.Next onClick={() => setCPN((cp) => Math.min(totalPages - 1, cp + 1))} />
             <Pagination.Last onClick={() => setCPN(totalPages - 1)} />
         </Pagination>
     );
 };
 
export default DataFramePagination;
